import{useContext}from'react';import SortProvider from"../providers/SortProvider.context";/**
 * Returns the value of the sort provider state.
 * @returns {Object}
 */export var useSort=function useSort(){return useContext(SortProvider);};